<template>
  <SelectWithRegister
    label="Grupo"
    id="autocomplete-group-default"
    v-model="input"
    :options="search"
    :search="onSearch"
    :change="change"
    :register="newGroup"
    :disabled="disabled"
    labelBusca="name"
    propsToShow="name"
    handle-register
  />
</template>

<script>
import SearchMixin from '@/core/mixins/SearchMixin';
import { SelectWithRegister } from '@/components/Form';
import { mapState } from 'vuex';

export default {
  name: 'AutocompleteGroup',
  components: {
    SelectWithRegister,
  },
  mixins: [SearchMixin],
  props: {
    value: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      collectionGroups: [],
      search: [],
      input: undefined,
    };
  },
  async mounted() {
    await this.getGroups();

    if (this.service.groupId) {
      const { groupId } = this.service;
      await this.setGroup(groupId);
    }
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
  computed: {
    ...mapState('service', ['service']),
  },
  methods: {
    async setGroup(id) {
      const { data } = await this.$http.post('inventory.get-group', { id });
      const [group] = data;

      this.$emit('input', group);
    },
    async getGroups() {
      const { data } = await this.$http.post('inventory.get-group');
      this.collectionGroups = data;
      this.search = data;
    },
    onSearch(value) {
      this.search = this.searchCollection(this.collectionGroups, value, 'name');
    },
    change(value) {
      this.$emit('input', value);
    },
    async newGroup(name) {
      const { data } = await this.$http.post('inventory.post-group', {
        name,
      });
      await this.getGroups();
      await this.setGroup(data.id);
    },
  },
};
</script>
